import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { a as useToggletipContext, b as useMergeRefs } from "../../../../chunks/useToggletip-DMdwuKzA.js";
import { c as clsx } from "../../../../chunks/clsx-DgYk2OaC.js";
import "../../../../foundations/icons/IconsDefault.js";
import { Text } from "../../../../foundations/typography/Text/Text.js";
import { ToggletipIcon } from "./ToggletipIcon.js";
import { s as styles } from "../../../../chunks/Toggletip.module-CjrKH5q1.js";
const ToggletipExplainer = forwardRef(function ToggletipExplainer2({ ariaLabel, showLabel, variant, className, ...props }, propRef) {
  const context = useToggletipContext();
  const ref = useMergeRefs([context.refs.setReference, propRef]);
  return /* @__PURE__ */ jsxs(
    "button",
    {
      ref,
      type: "button",
      className: clsx(
        styles.toggletipExplainer,
        showLabel ? styles.toggletipButton : styles.toggletipTrigger,
        className
      ),
      ...!showLabel && { "aria-label": ariaLabel },
      ...context.getReferenceProps(props),
      children: [
        /* @__PURE__ */ jsx(ToggletipIcon, { isActive: context.open, variant }),
        showLabel && /* @__PURE__ */ jsx(Text, { component: "span", className: clsx(styles[`toggletip-${variant}-text`]), children: ariaLabel })
      ]
    }
  );
});
export {
  ToggletipExplainer
};
